import { IS_DEVELOPMENT } from '../modules/envVars'
import apis from './apis'
import { axiosPost } from './axiosHelper'

export const track = async (params) => {
  const {
    location,
    log_type,
    log_category,
    lesson_id,
    course_id,
    webinar_video_id,
    webinar_id,
    youtube_id,
    article_id,
    ringle_expression_sample_id,
    answer_id,
    requested_text_id,
    duration,
    log_id,
    playback_time,
    curation_id,
  } = params
  const payload = {
    location: location,
    log_type: log_type,
    log_category: log_category,
    lesson_id: lesson_id,
    course_id: course_id,
    webinar_video_id: webinar_video_id,
    webinar_id: webinar_id,
    youtube_id: youtube_id,
    article_id: article_id,
    ringle_expression_sample_id: ringle_expression_sample_id,
    answer_id: answer_id,
    requested_text_id: requested_text_id,
    duration: duration,
    log_id: log_id,
    playback_time: playback_time,
    curation_id: curation_id,
  }

  if (IS_DEVELOPMENT) return
  const res = await axiosPost(apis.track(), payload).then((res) => {
    if (res?.success) {
      console.log(res)
    } else {
      console.log(res)
      console.log(payload)
    }
    return res
  })
  return res
}
